export default "__VITE_ASSET__Cdhl7qlE__"